import { Flex, Box } from "@chakra-ui/react";
import { useSlideInMenu } from "../hooks/useSlideInMenu";
import { useMobileBreakpoint } from "../../../utils/useBreakpoints";
import { SlideInHeader } from "../components/SlideInHeader";
import { SLIDE_IN_MENUS } from "../../../screens/root/constants";
import { AnimatePresence, motion } from "framer-motion";
import { FunnelConfigTypes } from "../../funnel/types";
import { useReleaseInfoPaywall } from "./hooks/useReleaseInfoPaywall";
import { useFunnel } from "../../funnel/hooks/useFunnel";
import { useMemo } from "react";
import {
  useSlideInFunnel,
  funnelAnimationVariants,
  menuAnimationVariants,
  transitionConfig,
} from "../hooks/useSlideInFunnel";
import { ReleaseInfoContent } from "./ReleaseInfoContent";

const MotionFlex = motion(Flex);

interface ReleaseInfoMenuProps {
  onCloseMenu?: () => void;
  onFunnelChange?: (funnelConfig: FunnelConfigTypes | undefined) => void;
}
export function ReleaseInfoMenuWrapper(props: ReleaseInfoMenuProps) {
  return <ReleaseInfoMenu {...props} />;
}

export function ReleaseInfoMenu({
  onCloseMenu,
  onFunnelChange,
}: ReleaseInfoMenuProps) {
  const {
    openReleaseInfoMenu,
    goBack,
    releaseUuid,
    navigationContext,
    menuInstanceId,
  } = useSlideInMenu();

  const { funnelConfig, setFunnelConfig, scrollContainerRef, handleBack } =
    useSlideInFunnel({ onFunnelChange, goBack });
  const isMobile = useMobileBreakpoint();

  const openPaywall = useReleaseInfoPaywall({ setFunnelConfig });

  const releaseInfoFunnelConfig = useMemo(() => {
    return {
      ...funnelConfig,
      setFunnelConfig,
    };
  }, [funnelConfig, setFunnelConfig]);

  const { funnelBody, funnelFooter } = useFunnel(releaseInfoFunnelConfig ?? {});

  return (
    <Flex
      flexDirection="column"
      height="100%"
      maxHeight={isMobile ? "100%" : "calc(100dvh - 32px)"}
      id="gcSlideInMenuContentContainer"
    >
      <SlideInHeader
        handleBack={handleBack}
        openMenu={SLIDE_IN_MENUS.releaseInfo}
        onCloseMenu={onCloseMenu}
      />
      <AnimatePresence initial={false} mode="wait">
        {funnelBody ? (
          <MotionFlex
            key="funnel"
            ref={scrollContainerRef}
            {...funnelAnimationVariants}
            transition={transitionConfig}
            className="styled-scrollbar"
            gap="24px"
            flexGrow={1}
            overflowY="auto"
            maxWidth="100%"
            flexDirection="column"
            minHeight={0}
          >
            <Box transition="padding 0.1s ease-in-out" transitionDelay={"0.1s"}>
              {funnelBody}
              {funnelFooter}
            </Box>
          </MotionFlex>
        ) : (
          <MotionFlex
            key="menu"
            {...menuAnimationVariants}
            transition={transitionConfig}
            className="styled-scrollbar"
            flexGrow={1}
            overflowY="auto"
            maxWidth="100%"
            flexDirection="column"
          >
            <ReleaseInfoContent
              releaseUuid={releaseUuid ?? ""}
              navigationContext={navigationContext}
              menuInstanceId={menuInstanceId}
              setFunnelConfig={setFunnelConfig}
              openPaywall={openPaywall}
              onSelectRelease={(uuid, slug) => {
                openReleaseInfoMenu(uuid, slug, {});
              }}
            />
          </MotionFlex>
        )}
      </AnimatePresence>
    </Flex>
  );
}
